import React from "react"

export default class Div extends React.Component {
  constructor(props){
    super(props)

    this.state = {
      canRenderChildren: props.canRenderChildren
    }
  }

  componentWillReceiveProps(nextProps){
    this.setState(nextProps)
  }

  _renderDisableView(){
    if(!this.props.disabled){
      return null
    }

    return (
      <div className="disable-view">
        { this._renderLoading() }
      </div>
    )
  }

  _renderLoading(){
    if(this.props.renderLoading){
      return this.props.renderLoading()
    }

    if(!this.props.showLoadingIndicator){
      return null
    }

    return (
      <div className="disable-view__loading">
        <div className="spinner-border text-primary" role="status" aria-hidden="true"></div>
        <div className="disable-view__text">{this.props.loadingText}</div>
      </div>
    )
  }

  render() {
    let {
      canRenderChildren
    } = this.state

    if(!canRenderChildren){
      return null
    }

    return (
      <div className={"relative "+this.props.className} style={this.props.style}>
        { this.props.children }
        { this._renderDisableView() }
      </div>
    )
  }
}

Div.defaultProps = {
  canRenderChildren: true,
  showLoadingIndicator: false,
  loadingText: "Loading..."
}
